// 写真の暗号化（仕様書「写真の暗号化」）。写真ごとに使い捨ての鍵（X25519）を作り、サーバーの公開鍵と合わせた鍵（HKDF）で AES-256-GCM で包む。
// 端末は公開鍵だけを持つ。開けるのは秘密鍵を持つサーバーだけ。端末とサーバーで同じ処理を使う
import { gcm } from '@noble/ciphers/aes';
import { x25519 } from '@noble/curves/ed25519';
import { hkdf } from '@noble/hashes/hkdf';
import { sha256 } from '@noble/hashes/sha2';
import { randomBytes } from '@noble/hashes/utils';

const INFO = new TextEncoder().encode('torapon-photo-v1');

function keyFor(shared: Uint8Array, ephPub: Uint8Array, recipientPub: Uint8Array) {
  const salt = new Uint8Array(64);
  salt.set(ephPub, 0);
  salt.set(recipientPub, 32);
  return hkdf(sha256, shared, salt, INFO, 32);
}

/** 包む。wrappedKey（使い捨ての公開鍵）と body（nonce＋暗号文）を別々に返す */
export function sealPhoto(plain: Uint8Array, recipientPub: Uint8Array) {
  const eph = x25519.utils.randomPrivateKey();
  const ephPub = x25519.getPublicKey(eph);
  const key = keyFor(x25519.getSharedSecret(eph, recipientPub), ephPub, recipientPub);
  const nonce = randomBytes(12);
  const ct = gcm(key, nonce, ephPub).encrypt(plain);
  const body = new Uint8Array(12 + ct.length);
  body.set(nonce, 0);
  body.set(ct, 12);
  return { wrappedKey: ephPub, body };
}

/** 開ける。書き換えられていれば例外 */
export function openPhoto(body: Uint8Array, wrappedKey: Uint8Array, recipientPriv: Uint8Array) {
  const recipientPub = x25519.getPublicKey(recipientPriv);
  const key = keyFor(x25519.getSharedSecret(recipientPriv, wrappedKey), wrappedKey, recipientPub);
  return gcm(key, body.subarray(0, 12), wrappedKey).decrypt(body.subarray(12));
}

export const toB64 = (b: Uint8Array) => { let s = ''; for (const x of b) s += String.fromCharCode(x); return btoa(s); };
export const fromB64 = (s: string) => Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
